// extracted by mini-css-extract-plugin
export default {"root":"EQRpARylETUscsVa79A9","placeHolderShimmer":"INzik0OG4evVYgeqf6xx"};